//证件号码严格验证
//身份证号合法性验证
//支持15位和18位身份证号
//支持地址编码、出生日期、校验位验证
export function IdentityCodeValid(code, cb) {
  var city = {
    11: "北京",
    12: "天津",
    13: "河北",
    14: "山西",
    15: "内蒙古",
    21: "辽宁",
    22: "吉林",
    23: "黑龙江 ",
    31: "上海",
    32: "江苏",
    33: "浙江",
    34: "安徽",
    35: "福建",
    36: "江西",
    37: "山东",
    41: "河南",
    42: "湖北 ",
    43: "湖南",
    44: "广东",
    45: "广西",
    46: "海南",
    50: "重庆",
    51: "四川",
    52: "贵州",
    53: "云南",
    54: "西藏 ",
    61: "陕西",
    62: "甘肃",
    63: "青海",
    64: "宁夏",
    65: "新疆",
    71: "台湾",
    81: "香港",
    82: "澳门",
    91: "国外 "
  };
  var tip = "";
  var pass = true;
  // if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
    if (!code || !/^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(code)) {
    cb("身份证号格式错误！")
  } else if (!city[code.substr(0, 2)]) {
    // tip = "地址编码错误";
    // pass = false;
    cb("身份证地址编码错误！")
  } else {
    //18位身份证需要验证最后一位校验位
    if (code.length == 18) {
      code = code.split('');
      //∑(ai×Wi)(mod 11)
      //加权因子
      var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      //校验位
      var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
      var sum = 0;
      var ai = 0;
      var wi = 0;
      for (var i = 0; i < 17; i++) {
        ai = code[i];
        wi = factor[i];
        sum += ai * wi;
      }
      if (parity[sum % 11] != code[17]) {
        console.log(parity[sum % 11])
        console.log(code[17])
        // tip = "校验位错误";
        // pass = false;
        if(code[17] === "x"){
          cb("身份证末尾x请输入大写！")
        }else{
          cb("身份证校验位错误")
        }
      }else{
        cb()
      }
    }else{
      cb("身份证号长度错误")
    }
  }
}


//js限制文件上传大小
export function limitFileSize (file, limitSize) {
  var arr = ["KB", "MB", "GB"]
  var limit = limitSize.toUpperCase();
  var limitNum = 0;
  for (var i = 0; i < arr.length; i++) {
      var leval = limit.indexOf(arr[i]);
      if (leval > -1) {
          limitNum = parseInt(limit.substr(0, leval)) * Math.pow(1024, (i + 1))
          break
      }
  }
  if (file.size > limitNum) {
      return false
  }
  return true
}

/**
 * 取出小括号内的内容
 * @param text
 * @returns {string}
 */
 export function getParenthesesStr(text) {
  let result = ''
  let regex = /\((.+?)\)/g;
  let options = text.match(regex)
  if (options) {
    for (var i = 0; i < options.length; i++) {
      result += options[i].replace(regex, "$1")
    }
}
  return result
}

//密码特殊字符验证
/* export function btKeyUp(name) {
  //空格回退
  this.pwdInfo[name] = this.pwdInfo[name].replace(/[, ]/g, "");
  // 不允许输入中文
  this.pwdInfo[name] = this.pwdInfo[name].replace(/[\u4e00-\u9fa5]/gi, "");
  // 不允许输入特殊符号
  this.pwdInfo[name] = this.pwdInfo[name].replace(
    /[^\w\u4E00-\u9FA5]/g,
    ""
  );
} */